import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'; 
import GetStarted from '../assets/images/get-started.svg' 
import HeadingLines from '../assets/images/white-heading-lines.svg'

function HowMuchDoesCost({data}) {
  return (
    <> 
    <section className="how-much-does-cost">
      <Container>
        <Row className="align-items-center">    
          <Col sm="12"> 
          <div className="common-header">
              <img src={HeadingLines} alt={data?.title} />
              <div dangerouslySetInnerHTML={{ __html: data?.title }}></div>
              <div dangerouslySetInnerHTML={{ __html: data?.description }}></div>  
            </div>   
            <div className="how-much-does-cost-box"> 
              <div dangerouslySetInnerHTML={{ __html: data?.btn_title }}></div>
              <Link to={data?.btn_link} title="Get Started" className="custom-bttn white-bttn"> <img className="arrow-icon-img" src={GetStarted} alt="" /> {data?.btn_name}</Link> 
            </div>
          </Col>
        </Row>        
      </Container>
    </section>
    </>
  )
}
export default HowMuchDoesCost